import React from "react";
import ManagerNavbar from "../Layout/ManagerNavbar";
import ChecklistPage from "../checklist/ChecklistPage";

export default function ManagerChecklistPage() {
  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <ManagerNavbar />
      <ChecklistPage />
    </div>
  );
}
